(function ($, Drupal) {
  Drupal.behaviors.profile = {
    attach: function (context, settings) {

      var profileImageGallery = context.querySelector('.profile-image-gallery__images .field--name-field-image-gallery-block');
      if (profileImageGallery) {
        $('.profile-image-gallery__images .field--name-field-image-gallery-block', context).bxSlider({
          mode: 'horizontal',
          infiniteLoop: true,
          adaptiveHeight: true,
          pager: false,
          auto: true,
          pause: 3000,
          preventDefaultSwipeX: false,
          maxSlides: 6,
          minSlides: 2,
          nextText: '',
          prevText: '',
          touchEnabled: true
        });
      }

      var sentFromInput = context.querySelector('.field--name-field-wu-sent-from .form-item input');
      if (sentFromInput) {
        var url = window.location.href;
        sentFromInput.setAttribute('value', url);
      }

      const infoIcons = document.querySelectorAll('.field--name-field-social-media .field--name-field-contact-info-icon');
      if (infoIcons && infoIcons.length > 0) {
        infoIcons.forEach(function (element) {
          var infoIconFacebook = element.querySelector('.fa-facebook-f');
          if (infoIconFacebook) {
            element.classList.add('social-link--facebook');
          }
          var infoIconTwitter = element.querySelector('.fa-twitter');
          if (infoIconTwitter) {
            element.classList.add('social-link--twitter');
          }
          var infoIconYoutube = element.querySelector('.fa-youtube');
          if (infoIconYoutube) {
            element.classList.add('social-link--youtube');
          }
          var infoIconLinkedin = element.querySelector('.fa-linkedin-in');
          if (infoIconLinkedin) {
            element.classList.add('social-link--linkedin');
          }
          var infoIconInstagram = element.querySelector('.fa-instagram');
          if (infoIconInstagram) {
            element.classList.add('social-link--instagram');
          }
        });
      }
      
    }
  };
})(jQuery, Drupal);
